/* eslint-disable no-case-declarations */

import {
    FETCH_DRAFTSORGANISATION_BEGIN,
    FETCH_DRAFTSORGANISATION_SUCCESS,
    FETCH_DRAFTSORGANISATION_FAILURE
} from '../Actions/DraftsOrganisationActions';

const initialState = {
    items: { 'draftRPAs': null, 'draftARNs': null},
    error: null,
    loaded: false
};

export default function DraftsOrganisationReducer(state = initialState, action) {

    switch (action.type) {

        case FETCH_DRAFTSORGANISATION_BEGIN:
            return {
                ...state,
                loaded: false,
                fetchDataBegin: true,
                error: null
            };

        case FETCH_DRAFTSORGANISATION_SUCCESS: {
            const draftRPAs = action.payload?.filter(el => el.title === "RPA Registration");
            const draftARNs = action.payload?.filter(el => el.title === "ARN application");

            return {
                ...state,
                items: {
                    'draftRPAs': draftRPAs,
                    'draftARNs': draftARNs
                },
                loaded: true,
                fetchDataBegin: false,
                error: null
            };
        }

        case FETCH_DRAFTSORGANISATION_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                items: [],
                fetchDataBegin: false,
                loaded: false
            };

        default:
            return state;
    }
}